import { render, staticRenderFns } from "./DialogEditWidgetChartComponent.vue?vue&type=template&id=6bb4ac74&"
import script from "./DialogEditWidgetChartComponent.vue?vue&type=script&lang=js&"
export * from "./DialogEditWidgetChartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports